import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Heading from "../../../../components/heading/Heading";
import { HEADING } from "../../../../components/heading/constants/constants";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import styles from './MultiSelectActionCard.styles'
import { componentKey, setActivateConfirmationModalOpen, setDeActivateConfirmationModalOpen, setDeleteConfirmationModalOpen, setGenerateReportDrawer, setHighlightedPayer, setPayersList, setSelectedPayers, setShowAssignToUserTable } from "../PayerListSlice";
import { ShowForAllowedPermissionsOnly } from "../../../wrappers/ShowForAllowedPermissionsOnly";
import { PAGE_PERMISSIONS } from "../../../dashboard/constants/constant";

export default function MultiSelectActionCard() {

    const dispatch = useDispatch();
    const { highlightedPayer, selectedPayers, payersList } = useSelector((state) => state[componentKey]);

    const activatedPayers = selectedPayers.filter((element) => element.IsActive);
    const deActivatedPayers = selectedPayers.filter((element) => !element.IsActive);

    const handleHideTinForSelectedPayers = (currentAction) => {
        const updatedPayersList = payersList.map(payer => {
            const indexOfPayer = selectedPayers.findIndex(p => p.PayerDetailId == payer.PayerDetailId)
            if (indexOfPayer >= 0) {
                return {
                    ...payer,
                    hideTIN: currentAction,
                }
            } else {
                return payer
            }
        })
        dispatch(setPayersList(updatedPayersList));
        const updatedSelectedPayers = selectedPayers.map(payer => {
            return {
                ...payer,
                hideTIN: currentAction,
            };
        });
        dispatch(setSelectedPayers(updatedSelectedPayers));
        const hideTIN = currentAction;
        const updatedHighlightedPayer = { ...highlightedPayer, hideTIN };
        dispatch(setHighlightedPayer(updatedHighlightedPayer));
    }

    return (
        <>
            <div style={styles.header}>
                <Icons familyName='vec' iconName={VEC_ICON_NAME.MULTIPLE_SELECT_ICON} />
                <Heading type={HEADING.H1} customStyle={{ margin: "0" }}>You have selected {selectedPayers.length} {selectedPayers.length === 1 ? "Payer!" : "Payers!"}</Heading>
                <p style={styles.headerText}>Here are some recommended actions for you</p>

            </div>

            <div style={styles.buttonsContainer}>

                <Button
                    type={BUTTON_TYPE.PRIMARY}
                    style={styles.button}
                    onClickCb={() => handleHideTinForSelectedPayers(selectedPayers[0].hideTIN == false ? true : false)}
                >
                    {`${selectedPayers[0].hideTIN == false ? 'Hide' : 'Show'} TIN`}
                </Button>

            </div>

            <div style={styles.buttonWithOutBorder}>
                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.ASSIGN_TO_USER_ICON }}
                    onClickCb={() => dispatch(setShowAssignToUserTable(true))}
                >
                    Assign to User
                </Button>

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => dispatch(setGenerateReportDrawer(true))}
                >
                    Generate Report
                </Button>

                <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.EDIT_PAYERS}>
                    {activatedPayers?.length !== 0 && <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.DEACTIVATE_ICON }}
                        onClickCb={() => dispatch(setDeActivateConfirmationModalOpen(true))}
                    >
                        Deactivate <span>{activatedPayers?.length}</span>
                    </Button>}


                    {deActivatedPayers?.length !== 0 && <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.ASSIGN_TO_USER_ICON }}
                        onClickCb={() => dispatch(setActivateConfirmationModalOpen(true))}
                    >
                        Activate <span>{deActivatedPayers?.length}</span>
                    </Button>}
                </ShowForAllowedPermissionsOnly>
                
                <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.DELETE_PAYERS}>
                    <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.DELETE_ICON }}
                        onClickCb={() => dispatch(setDeleteConfirmationModalOpen(true))}
                    >
                        Delete
                    </Button>
                </ShowForAllowedPermissionsOnly>
            </div>
        </>
    )
}